import React, { useMemo } from 'react';
import { HelpText } from './HelpText';
var FormGroupLabel = function (_a) {
    var className = _a.className, id = _a.id, helpText = _a.helpText, isRequired = _a.isRequired, label = _a.label, feedback = _a.feedback, isRounded = _a.isRounded, children = _a.children, valid = _a.valid, invalid = _a.invalid;
    var renderHelpText = useMemo(function () {
        return React.createElement(HelpText, { isRounded: isRounded }, helpText);
    }, [helpText, isRounded]);
    var renderFeedback = useMemo(function () {
        if (feedback) {
            return (React.createElement("p", { className: 'mb-0 gr-feedback ' +
                    (isRounded ? 'mx-x4 ' : '') +
                    (invalid ? 'invalid ' : '') +
                    (valid ? 'valid ' : '') }, feedback));
        }
        else {
            return null;
        }
    }, [feedback, invalid, isRounded, valid]);
    return (React.createElement("div", { className: 'gr-form-group ' + (className ? className : '') },
        label && (React.createElement("label", { htmlFor: id, className: 'label-size ' + (isRounded ? 'label-space' : '') }, label + (isRequired ? '*' : ''))),
        children,
        renderFeedback,
        renderHelpText));
};
export { FormGroupLabel };
//# sourceMappingURL=FormGroupLabel.js.map